import { styled } from '@mui/material/styles';
import config from '../config.client';

const LogoStyled = styled('div')(({ theme }) => ({
    img: {
        width: '12rem',
        height: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: '8rem',
        },
    },
}));

const LogoHandStyled = styled('div')`
    img {
        width: 3rem;
    }
`;
const Logo = (): JSX.Element => <LogoStyled> <a href="/" title={`${config.companyName} - דרושים`}>
    <img alt={`${config.companyName} - דרושים`}
        src={config.largeLogoSrc} />
</a></LogoStyled>;

export const LogoHand = (): JSX.Element => <LogoHandStyled><a href="/" title={`${config.companyName} - דרושים`}>
    <img alt={`${config.companyName} - דרושים`}
        src={config.smallLogoSrc} />
</a></LogoHandStyled>;

export default Logo;
